/**
 * Defined in:
 *   {@link file://./../../../dxos/mesh/bridge.proto}
 */
export var ConnectionState;
(function (ConnectionState) {
    ConnectionState[ConnectionState["INVALID"] = 0] = "INVALID";
    ConnectionState[ConnectionState["CONNECTING"] = 1] = "CONNECTING";
    ConnectionState[ConnectionState["CONNECTED"] = 2] = "CONNECTED";
    ConnectionState[ConnectionState["CLOSED"] = 3] = "CLOSED";
})(ConnectionState || (ConnectionState = {}));
//# sourceMappingURL=bridge.js.map